package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.legend.LegendAlign
import pl.decks.chartjs.legend.LegendPosition
import pl.decks.chartjs.radar.options.plugins.LegendOptions

@RadarDsl
class LegendScope {
    var display: Boolean = true
    var position: LegendPosition = LegendPosition.Top
    var align: LegendAlign = LegendAlign.Center
    var reverse: Boolean = false
    private var labelScope: LegendLabelScope? = null
    private var titleScope: LegendTitleScope? = null

    fun labels(block: LegendLabelScope.() -> Unit) {
        labelScope = LegendLabelScope().apply(block)
    }

    fun title(block: LegendTitleScope.() -> Unit) {
        titleScope = LegendTitleScope().apply(block)
    }

    internal fun build() = LegendOptions(
        display = display,
        position = position,
        align = align,
        reverse = reverse,
        labels = labelScope?.build(),
        title = titleScope?.build(),
    )
}
